import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hipaa-authorizations"
export default class extends Controller {
  static targets = [
    "lastServiceDateContainer", 
    "lastServiceDateText", 
    "lastServiceDateValue", 
    "guardianNameContainer", 
    "isGuardianCheckbox",
    "patientInfoCardContainer",
    "patientInfoFormContainer",
    "billInfoCardContainer",
    "billInfoFormContainer"
  ]

  connect() {
    // We want to automatically reveal the last-service-date element if we have a value
    // for the last service date or we have an error.
    if (this.lastServiceDateValueTarget.getAttribute("data-value") || document.getElementById("last_service_date_error").innerText != "") {
      this.openLastServiceDate();
    }

    this.openGuardianName();
  }

  openLastServiceDate(event) {
    this.lastServiceDateTextTarget.classList.add("hidden")
    this.lastServiceDateContainerTarget.classList.remove("hidden")
    this.lastServiceDateContainerTarget.classList.add("block")
  }

  openGuardianName(event) {
    if (this.isGuardianCheckboxTarget.checked) {
      this.guardianNameContainerTarget.classList.remove("hidden")
      this.guardianNameContainerTarget.classList.add("block")
    } else {
      this.guardianNameContainerTarget.classList.remove("block")
      this.guardianNameContainerTarget.classList.add("hidden")
    }
  }

  togglePatientInfo(event) {
    this.patientInfoCardContainerTarget.classList.toggle("hidden")
    this.patientInfoFormContainerTarget.classList.toggle("hidden")
  }

  toggleBillInfo(event) {
    this.billInfoCardContainerTarget.classList.toggle("hidden")
    this.billInfoFormContainerTarget.classList.toggle("hidden")
  }
}
